import React from "react";

export default function Actions({ className, children }: { className?: string; children?: React.ReactNode }) {
  return (
    <div className={`flex content-end items-center gap-2 ${className}`}>
      {children}
    </div>
  );
}
